import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)``;

export const UpdradeLink = styled(Button)`
  /* display: flex;
  justify-content: center;
  align-items: center;
  height: ${(p) => p.theme.spacing(3.5)};
  text-decoration: none;
  border: 1px solid ${(p) => p.theme.palette.grey[300]};
  border-radius: ${(p) => p.theme.spacing(0.5)};
  padding: ${(p) => p.theme.spacing(0, 1)};
  color: ${(p) => p.theme.palette.common.black};

  &:hover {
    border-color: ${(p) => p.theme.palette.grey[400]};
    -moz-box-shadow: 0 0 0 4px ${(p) => p.theme.palette.grey[100]};
    -webkit-box-shadow: 0 0 0 4px ${(p) => p.theme.palette.grey[100]};
    box-shadow: 0 0 0 4px ${(p) => p.theme.palette.grey[200]};
  } */
`;
